import "~/stylesheets/index.css";
import "~/controllers";
import "~/lib/row_flash";
import "@hotwired/turbo-rails";
import "bootstrap";

// Detect browser timezone and store in cookie for server-side use
const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
if (tz) {
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `browser.timezone=${tz}; path=/; max-age=31536000; SameSite=Lax${secure}`;
}
